let load_more_btn = document.getElementsByClassName('load-more_btn')[0];
let load_more_spinner = document.getElementsByClassName('load-more_spinner')[0];

async function loadMoreProducts() {
    let products_on_page = document.getElementById('product-grid');
    let next_url = products_on_page.dataset.nextUrl;
    async function getNextPage() {
      try {
        let res = await fetch(next_url);
        return await res.text();
      } catch (error) {
        console.log(error);
      }
    }
    load_more_btn.style.display = 'none';
    load_more_spinner.style.display = 'flex';
    let nextPage = await getNextPage();
  
    const parser = new DOMParser();
    const nextPageDoc = parser.parseFromString(nextPage, 'text/html');
  
    load_more_spinner.style.display = 'none';
  
    const productgrid = nextPageDoc.getElementById('product-grid');
    const new_products = productgrid.getElementsByClassName('grid__item');
    const new_url_next = productgrid.dataset.nextUrl;
  
    for (let i = 0; i < new_products.length; i++) {
      let single_product = new_products[i].cloneNode(true);
      products_on_page.appendChild(single_product);
    }

    colorElements();
    const productGridcs = document.getElementById('product-grid');
    if (new_url_next) {
      if (productGridcs) {
        productGridcs.removeAttribute('data-next-url');
        productGridcs.setAttribute('data-next-url', new_url_next);
      }
      load_more_btn.style.display = 'flex';
    } else {
        productGridcs.removeAttribute('data-next-url');
    }
    return new_url_next
}

